import { render, staticRenderFns } from "./syncro-send-contact-widget.vue?vue&type=template&id=76b18c79&scoped=true&"
import script from "./syncro-send-contact-widget.vue?vue&type=script&lang=js&"
export * from "./syncro-send-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./syncro-send-contact-widget.vue?vue&type=style&index=0&id=76b18c79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b18c79",
  null
  
)

export default component.exports